import { render, staticRenderFns } from "./BulkReviewDialog.vue?vue&type=template&id=3f31eb06"
import script from "./BulkReviewDialog.vue?vue&type=script&lang=js"
export * from "./BulkReviewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports